import React, { FunctionComponent } from 'react';
import {
  StyledTitle,
  AutocompleteMenu,
  AutocompleteItemList,
} from '../../../core/forms/AutocompleteInput';
import { AffiliationSearch } from '../../../interfaces/register';
import { sortByAlphabet } from '../../../utils/shared/helpers';

interface AffiliationMenu {
  affiliations: AffiliationSearch[];
}

const PopularAffiliationMenu: FunctionComponent<AffiliationMenu> = ({
  affiliations,
}: AffiliationMenu) => {
  const sortedAffiliations = sortByAlphabet(affiliations);

  return (
    <AutocompleteMenu>
      <StyledTitle color="secondary" bold>
        Popular options
      </StyledTitle>
      <AutocompleteItemList items={sortedAffiliations} />
    </AutocompleteMenu>
  );
};
export default PopularAffiliationMenu;
